export function getCreatedResponse(response) {
  const now = Date.now();
  const newResponse = {
    id: '_' + now,
    ...response
  };

  return newResponse;
}
